import { Component, AfterContentInit, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { PlycaDataService } from '../../../services/plyca.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { Configuration } from '../../conf/app.constants';
import { BaseObjectDTO, DivisionDTO, DocumentDTO, Link, TaskDTO, getSimpleIdentifierFromString } from '../../api/plyca-dtos';
import { UIService } from '../../ui.service';
import { FieldConfig } from '../../api/contract-notice-dto';
import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';
import { ActionDefinitionDTO, AwardDTO, ObjectContextDTO } from '../../api/plyca-dtos-v2';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { finalize } from 'rxjs/operators';
import * as lodash from 'lodash';
import { FormConfig } from '../../components/forms/form.objects';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';


export class DivisionFilterDTO {
  award: AwardDTO;
}


export interface UnitPriceLineDTO extends BaseObjectDTO<string> {
  description: string;
  date: Date;
  creationDate: Date;
  backgroundFE: boolean;
  orderNumber: number;
  document: DocumentDTO;
  division: DivisionDTO;
  award: AwardDTO;
}

export class RelationUnitPricesDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  context?: ObjectContextDTO;

  division: DivisionDTO;
  document: DocumentDTO;

  projectUnitPrice: UnitPriceLineDTO[];
  divisionUnitPrice: UnitPriceLineDTO[];
  filterDivisionUnitPrice: UnitPriceLineDTO[];

}

@Component({
  selector: 'unitPriceRelationDocumentAYMAD',
  templateUrl: 'unitPriceRelationDocumentAYMAD.template.html',
  providers: [DialogService]
})

export class UnitPriceRelationDocumentComponentAYMAD extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  loaded = false;


  projectIdentifier: string;
  normaliceProjectIdentifier: string;
  unitPriceRelationDocuments: RelationUnitPricesDTO;
  _divisionId = 0;

  selectedDivision: DivisionDTO;

  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfig1: FormConfig;
  public filterModel: DivisionFilterDTO;


  constructor(
    public plycaService: PlycaDataService,
    private elem: ElementRef,
    public configuration: Configuration,
    public uiService: UIService,
    public dialogService: DialogService,
    public waitService: WaitLoadingService,
    public headerActionsService: HeaderActionsService,
    public activatedRoute: ActivatedRoute,
    public plycaErrorHandler: PlycaErrorHandler
  ) {
    super();
    this.load();
  }

  private load(showWait = true): void {
    if (showWait) {
      this.waitService.startWaiting();
    }
    this.loaded = false;
    this.subscribe(this.activatedRoute.params, params => {
      this.projectIdentifier = params['id'];
      let url = this.configuration.UNITPRICERELATIONDOCUMENT_SERVICE_URL.replace('{dossierId}', this.projectIdentifier);



      let serviceParams = {};
      // Se consulta por expediente y oferta
      serviceParams['projectId'] = this.projectIdentifier;



      this.subscribe(
        this.plycaService.get<any>(
          this.configuration.UNITPRICERELATIONDOCUMENT_SERVICE_URL, this.projectIdentifier
        ).pipe(
          finalize(() => {
            this.loaded = true;
            this.waitService.cancelWaiting();
          })
        ),
        results => {
          if (results) {
            this.normaliceProjectIdentifier = this.projectIdentifier.substring(0, 4) + '/' + this.projectIdentifier.substring(4);
            this.unitPriceRelationDocuments = results;
            if (this.unitPriceRelationDocuments.projectUnitPrice && this.unitPriceRelationDocuments.projectUnitPrice.length) {
              this.unitPriceRelationDocuments.projectUnitPrice.forEach(projectLine => {
                if (projectLine?.document?.entity?.documentClass?.abbreviation === 'FE') {
                  projectLine.backgroundFE = true;
                } else {
                  projectLine.backgroundFE = false;
                }
              });
            }

            if (this.unitPriceRelationDocuments?.divisionUnitPrice && this.unitPriceRelationDocuments.divisionUnitPrice.length >= 1) {
              // Comprobar si existe al menos un objeto con award distinto de nulo
              // Filtrar los objetos con award distinto de nulo
              let awardUnitPrice: UnitPriceLineDTO[] = [];
              awardUnitPrice = this.unitPriceRelationDocuments?.divisionUnitPrice.filter(item => item.award !== undefined);

              // Verificar si exactamente uno de los objetos tiene award distinto de nulo
              if (awardUnitPrice !== null && awardUnitPrice.length === 1) {
                this.unitPriceRelationDocuments.filterDivisionUnitPrice = this.unitPriceRelationDocuments.divisionUnitPrice;
                this.selectedDivision = awardUnitPrice[0].division;
                // Si solo hay un adjudicatario, el servidor lo devuelve.
                this.filterModel.award = awardUnitPrice[0].award;
                // console.log('************************************************** Exactamente un objeto tiene award distinto de nulo.');
              }

            }


            if (this.unitPriceRelationDocuments?.divisionUnitPrice && this.unitPriceRelationDocuments.divisionUnitPrice.length === 1) {
              this.unitPriceRelationDocuments.filterDivisionUnitPrice = this.unitPriceRelationDocuments.divisionUnitPrice;
              // this.selectedDivision = this.unitPriceRelationDocuments.divisionUnitPrice[0].division;
              // Si solo hay un adjudicatario, el servidor lo devuelve.
              // this.filterModel.award = this.unitPriceRelationDocuments.divisionUnitPrice[0].award;

            }

            this.loaded = true;
            if (showWait) {
              this.waitService.cancelWaiting();
            };
          }
          this.loaded = true;
        },
        error => {
          this.waitService.cancelWaiting();
          this.plycaErrorHandler.showServerError(error)
        });


      this.dtoToModel();


      /*this.subscribe(this.plycaService.get<RelationUnitPricesDTO>(url, 'loadUnitPriceRelationDocuments'),
        (RelationUnitPricesDTO: RelationUnitPricesDTO) => {
          this.normaliceProjectIdentifier = this.projectIdentifier.substring(0, 4) + '/' + this.projectIdentifier.substring(4);
          this.unitPriceRelationDocuments = RelationUnitPricesDTO;
          this.unitPriceRelationDocuments.filterDivisionUnitPrice = this.unitPriceRelationDocuments.divisionUnitPrice;
          this.loaded = true;
          if (showWait) {
            this.waitService.cancelWaiting();
          }
        },
        (error: any) => this.plycaErrorHandler.showServerError(error),
        () => {
          this.loaded = true;
          if (showWait) {
            this.waitService.cancelWaiting();
          }
        });*/
    });
  }

  ngAfterContentInit(): void {
    this.headerActionsService.setTaskDescription(
      this.elem,
      'Relacion de precios Unitarios',
      'fa-file-contract',
      true
    );
    this.headerActionsService.clearActions();
    this.subscribe(this.headerActionsService
      .addAction(
        'General.back',
        'fas fa-chevron-left fa-lg',
        'btn-outline-secondary',
        true
      ),
      () => {
        this.uiService.routeBack();
      });
  }

  ngOnInit(): void {
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  public getBuscadorDivisionTree(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'DIVISION';
    config.jsonField = 'selectedDivision';
    config.description = 'Filtro de divisiones';
    config.fieldStyle = 'plForm-element';
    config.idBuscador = this.projectIdentifier;
    return config;
  }



  filterDivisionList() {
    this.unitPriceRelationDocuments.filterDivisionUnitPrice = this.unitPriceRelationDocuments.divisionUnitPrice.filter(line => {
      let divisionIdentifier = Number(getSimpleIdentifierFromString(line.division.identifier));
      let divisionParentIdentifier = Number(getSimpleIdentifierFromString(line.division.parent.identifier));
      console.log(
        'comparando DIVISION ACTUAL',
        divisionIdentifier,
        String(this._divisionId)
      ); console.log(
        'comparando DIVISION PARENT',
        divisionParentIdentifier,
        String(this._divisionId)
      );
      console.log('resultado division actual: ' + divisionIdentifier !== undefined && divisionIdentifier === this._divisionId);
      console.log('resultado division PARENT: ' + divisionParentIdentifier !== undefined && divisionParentIdentifier === this._divisionId);
      return ((divisionIdentifier !== undefined && divisionIdentifier === this._divisionId) ||
        (divisionParentIdentifier !== undefined && divisionParentIdentifier === this._divisionId));
    });
  }

  openDocument(unitPriceLine: UnitPriceLineDTO) {
    if (unitPriceLine?.document) {
      let config: DynamicDialogConfig = {
        header: unitPriceLine.document.name,
        width: '97%',
        styleClass: 'searchStyle'
      };

      config.data = {
        'id': unitPriceLine.document.identifier

      }
      let modal = this.dialogService.open(documentViewerComponent, config);
      this.subscribe(modal.onClose);
    }
  }

  public viewUnitPrice(model: any) {
    let selectedLine: UnitPriceLineDTO;
    selectedLine = model;

    this.subscribe(this.plycaService.getAction('EXPORT_UNITPRICE_TO_EXCEL'), (datos: any) => {

      if (datos && datos.content) {

        let relationUnitPricesDTO: RelationUnitPricesDTO;
        relationUnitPricesDTO = new RelationUnitPricesDTO();
        relationUnitPricesDTO.projectUnitPrice = [];
        relationUnitPricesDTO.projectUnitPrice.push(selectedLine);




        relationUnitPricesDTO.division = selectedLine.division;


        let actionDefinition: ActionDefinitionDTO = datos.content[0];

        if (actionDefinition && actionDefinition.executableAction) {
          let action = actionDefinition.executableAction;
          action.parameters = action.parameters.filter(
            (param) => param.name !== 'TARGET'
          );

          let tmp: any;
          tmp = lodash.cloneDeep(relationUnitPricesDTO);


          tmp = JSON.parse(
            JSON.stringify(tmp, (k, v) => (k === '_parent' ? undefined : v))
          );



          action.target = relationUnitPricesDTO;
          action.target.class = 'com.nexusit.plyca.api.userAPI.v1.contractingconcept.unitprice.RelationUnitPricesDTO';

          let config: DynamicDialogConfig = {
            header: actionDefinition.executableAction.name,
            width: '70%',
            styleClass: 'actionStyle',
          };
          config['action'] = action;
          config['dto'] = actionDefinition.executableAction.target;
          config['runAction'] = true;

          const ref = this.dialogService.open(ActionsProcessComponent, config);
          this.subscribe(ref.onClose, (result: any) => {
            if (result && result.length) {
              console.log('Importados precios unitarios');
              // this.formPlycaRef.updateView();
            }
          });
        }
      }
    });
  }

  private createFormConfig1(): Observable<FormConfig> {

    return of(new FormConfig(undefined,
      'unitPriceRelationDocument/unitPriceRelationDocumentFilterISttings.json',
      this.filterModel
    ));
  }

  dtoToModel() {


    this.filterModel = new DivisionFilterDTO();

    this.subscribe(this.createFormConfig1(),
      (form1: FormConfig) => {
        this.formConfig1 = form1;

        this.formConfig1.functions.push({
          identifier: 'changeDivision',
          fn: this.changeDivision.bind(this)
        });

        this.formConfig1.functions.push({
          identifier: 'getProjectIdentifier',
          fn: this.getProjectIdentifier.bind(this)
        });

        this.formConfig1.functions.push({
          identifier: 'getTextAward',
          fn: this.getTextAward.bind(this)
        });

      });

  }

  getProjectIdentifier() {
    return this.projectIdentifier;
  }

  changeDivision(model: any) {
    this.selectedDivision = model?.award?.division;
    if (this.selectedDivision && this.selectedDivision.identifier) {
      this._divisionId = Number(getSimpleIdentifierFromString(this.selectedDivision.identifier));
      if (this._divisionId === 0) {
        this.unitPriceRelationDocuments.filterDivisionUnitPrice = [];
      } else {
        this.filterDivisionList();
      }
    } else {
      this._divisionId = undefined;
      this.unitPriceRelationDocuments.filterDivisionUnitPrice = [];
    }
  }

  public getTextAward(model: any) {
    let desc = '';
    if (model.award && model.award.company) {
      desc = model?.award?.company?.taxIdentifier + ' - ' + model?.award?.company?.commercialName
      let lotNumbers: number[] = []; // Cambio: Ahora lotNumbers es un array de enteros
      if (model.award?.awardsLots !== undefined && model.award.awardsLots.length > 0) {
        model.award.awardsLots.forEach(awardLot => {
          if (awardLot.projectLot?.lotNumber !== undefined && awardLot.projectLot?.lotId !== 0) {
            lotNumbers.push(awardLot.projectLot?.lotNumber); // Cambio: Añadir el número del lote al array
          }
        });
        if (lotNumbers.length > 1) { // Si hay más de un dato en el array
          lotNumbers.sort((a, b) => a - b); // Ordenar en orden creciente
        }
      }

      /*let lotNumbers: number[] = []; // Cambio: Ahora lotNumbers es un array de enteros
      if (model.award?.awardsLots !== undefined && model.award.awardsLots.length > 0) {
        model.award.awardsLots.forEach(awardLot => {
          if (lotNumbers === '') {
            lotNumbers = awardLot?.projectLot?.lotNumber;
          } else {
            lotNumbers = lotNumbers + ',' + awardLot.projectLot?.lotNumber;
          }
        });
      }*/
      desc = desc + ' ' + lotNumbers;
    }
    return desc;
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

}
